import { Component, OnInit, Input } from '@angular/core';
import moment from "moment";

@Component({
    selector: 'app-flight-card',
    templateUrl: './flight-card.component.html',
    styleUrls: ['./flight-card.component.scss'],
    standalone: false
})
export class FlightCardComponent implements OnInit {

  @Input() flightDetails: any = {};
  @Input() lastSegment;
  @Input() lastSlice;
  @Input() localeStr;
  @Input() timeFormat;
  departureDate: string = '';
  arrivalDate: string = '';
  nextDayArrival: string = '';
  nextDayDeparture: string = '';

  ngOnInit() {
    this.departureDate = moment(this.flightDetails.departDateNoTimeZone).format('dddd, LL');
    this.arrivalDate = moment(this.flightDetails.arrivalDateNoTimeZone).format('dddd, LL');
    if (this.flightDetails.nextDayArrivalAlert) {
      this.nextDayArrival = moment(this.flightDetails.arrivalDateNoTimeZone).locale(this.localeStr).format('MMMM DD');
    }
    if (this.flightDetails.nextDayDepartureAlert) {
      this.nextDayDeparture = moment(this.flightDetails.departDateNoTimeZone).locale(this.localeStr).format('MMMM DD');
    }
  }

}
